var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardBlank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 32H64C28.652 32 0 60.654 0 96V416C0 451.346 28.652 480 64 480H512C547.348 480 576 451.346 576 416V96C576 60.654 547.348 32 512 32ZM160 376C160 380.418 156.418 384 152 384H72C67.582 384 64 380.418 64 376V360C64 355.58 67.582 352 72 352H152C156.418 352 160 355.58 160 360V376ZM352 376C352 380.418 348.418 384 344 384H200C195.582 384 192 380.418 192 376V360C192 355.58 195.582 352 200 352H344C348.418 352 352 355.58 352 360V376Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardBlank);
export default __webpack_public_path__ + "static/media/credit-card-blank.2d93f4e3609ee4e21a389b2d6e325f55.svg";
export { ForwardRef as ReactComponent };